import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'ctr-info-card',
  imports: [MatIconModule],
  templateUrl: './info-card.component.html',
  styleUrl: './info-card.component.scss',
})
export class InfoCardComponent {
  @Input() label = '';
  @Input() actionText = '';
  @Input() alignIcon: 'start' | 'end' | 'center' = 'center';
  @Output() action: EventEmitter<void> = new EventEmitter();

  onAction() {
    this.action.emit();
  }
}
